import qs from 'query-string';
import { all, put, takeLatest } from 'redux-saga/effects';

import {
  GET_SELFIE_LIST,
  GET_SELFIE_LIST_FAILURE,
  GET_SELFIE_LIST_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetSelfieList({ payload }) {
  const { startDate, endDate, taskCode, officeId, userId, page } = payload;
  try {
    const queryParams = {
      start: startDate,
      end: endDate,
      office_id: officeId,
      employee_id: userId,
      page: page
    };

    const keysOrder = Object.keys(queryParams);
    const queryString = qs.stringify(queryParams, {
      skipEmptyString: true,
      skipNull: true,
      sort: (a, b) => keysOrder.indexOf(a) - keysOrder.indexOf(b),
    });

    const url = `albait/attendance-photo-evidences/?${queryString}`;

    const response = yield defaultApi(url, 'GET', null);

    yield put({
      type: GET_SELFIE_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SELFIE_LIST_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_SELFIE_LIST, handleGetSelfieList),
  ]);
}
